export default "__VITE_ASSET__Cl29VCX6__"